/**
 * Client Image Data
 * Data object containing information about client images for the carousel.
 *
 * @type {Array<Object>}
 * @property {number} id - Unique identifier for the client image.
 * @property {string} Image - Image path for the client.
 */

export const settings = {
  dots: true,
  autoplay: true,
  infinite: true,
  speed: 1500,
  slidesToShow: 6,
  slidesToScroll: 6,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
};

export const CLIENT_IMAGE = [
  { img: '/images/services/ClientLogo/QuickShift.png' },
  { img: '/images/services/ClientLogo/WanderLooms.png' },
  { img: '/images/services/ClientLogo/Firstcry.webp' },
  { img: '/images/services/ClientLogo/Naykaa.png' },
  { img: '/images/services/ClientLogo/Samsung.webp' },
  { img: '/images/services/ClientLogo/MCaffeine.png' },
  { img: '/images/services/ClientLogo/Lenskart.webp' },
  { img: '/images/services/ClientLogo/Ubanic.png' },
  { img: '/images/services/ClientLogo/Incubate.png' },
  { img: '/images/services/ClientLogo/More.png' },
  { img: '/images/services/ClientLogo/Prozoo.png' },
  { img: '/images/services/ClientLogo/Pilgrim.png' },
  { img: '/images/services/ClientLogo/mamaearth.png' },
  { img: '/images/services/ClientLogo/Citymall.png' },
  { img: '/images/services/ClientLogo/Naaptol.png' },
];
